<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="达人名称" label-width="80px">
        <el-input v-model="searchForm.name" clearable placeholder="达人名称">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getList()">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
            v-if="hasAuth('sys:store:add')"
            style="margin-bottom: 20px;"
            type="primary"
            @click="setsu('null')"
        >添加
        </el-button
        >
      </el-form-item>
    </el-form>

    <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%;"
    >
      <el-table-column
          align="center"
          label="达人名称"
          prop="name"
          width="200"
      />
      <el-table-column
          align="center"
          label="达人二维码"
          min-width="200"
          prop="address"
      >
        <template slot-scope="{ row }">
          <el-image
              :preview-src-list="[row.codeImg]"
              :src="row.codeImg"
              style="width: 100px; height: 60px;"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          label="扫码下单人数"
          prop="num"
          width="120"
      >
        <template slot-scope="{ row }">
          <span style="color:red;cursor: pointer" @click="scan(row)"> {{ row.num || "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          label="达人位置"
          min-width="200"
          prop="address"
      >
        <template slot-scope="{ row }">
          {{ row.province || "" }}-{{ row.city || "" }}-{{
            row.county || ""
          }}<br/>
          {{ row.address || "" }}
        </template>
      </el-table-column>

      <el-table-column
          align="center"
          label="达人管理员"
          prop="userName"
          width="160"
      >
        <template slot-scope="{ row }">
          {{ row.userName || "" }} - {{ row.userPhone || "" }}
        </template>
      </el-table-column
      >
      <el-table-column
          align="center"
          label="达人联系方式"
          prop="phone"
          width="160"
      />

      <el-table-column
          align="center"
          fixed="right"
          label="操作"
          prop="icon"
          width="400"
      >
        <template slot-scope="scope">
          <el-button
              v-if="hasAuth('sys:store:edit')"
              plain
              type="primary"
              @click="UpdateButton(scope.row)"
          >编辑
          </el-button
          >
          <el-button
              v-if="hasAuth('sys:store:gengai')"
              plain
              type="primary"
              @click="xggly(scope.row)"
          >更改管理员
          </el-button
          >
          <el-button
              v-if="hasAuth('sys:store:download')"
              plain
              type="info"
              @click="downloadByBlob(scope.row)"
          >二维码下载
          </el-button
          >
          <el-popconfirm
              v-if="hasAuth('sys:store:del')"
              title="确定删除吗？"
              @confirm="delHandle(scope.row.id)"
          >
            <el-button slot="reference" plain type="danger">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="searchForm.pageNo"
        :page-size="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
        :before-close="handleClose"
        :title="editForm.id ? '编辑' : '新增'"
        :visible.sync="dialogVisible"
        append-to-body
        width="50%"
    >
      <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          class="demo-editForm"
          label-width="160px"
      >
        <el-form-item label="达人名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="管理员" prop="userId">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.nickName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                  icon="el-icon-search"
                  style="height: 40px; width: 100%;"
                  type="primary"
                  @click="selectUser"
              >选择
              </el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="达人位置" prop="prov">
          <el-cascader
              v-model="editForm.prov"
              :options="area"
              :props="{ value: 'name', label: 'name', children: 'area' }"
              clearable
              style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="达人详细地址" prop="address">
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
        <el-form-item label="达人介绍" prop="introduction">
          <el-input
              v-model="editForm.introduction"
              :rows="2"
              type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="达人封面" prop="cover">
          <VploadImgs
              v-if="dialogVisible"
              :limit="1"
              :multble="false"
              :type="1"
              v-bind:file-list="filelist"
              @submitImg="getImg"
          >
          </VploadImgs>
        </el-form-item>
        <div style="height: 30px;"></div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
          >提交
          </el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        :before-close="handlClose"
        :visible.sync="visible"
        append-to-body
        title="选择人员"
        width="80%"
    >
      <div style="padding-bottom: 40px;">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
                v-model="usersearchForm.name"
                clearable
                placeholder="用户昵称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="80px">
            <el-input
                v-model="usersearchForm.phone"
                clearable
                placeholder="手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getStoreGoods()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="userList" border stripe style="width: 100%;">
          <el-table-column align="center" label="用户头像" min-width="120">
            <template slot-scope="scope"
            ><img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
            />
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="用户昵称"
              min-width="120"
              prop="nickName"
          ></el-table-column>
          <el-table-column
              align="center"
              label="用户手机号"
              min-width="120"
              prop="phone"
          ></el-table-column>
          <el-table-column
              align="center"
              label="性别"
              min-width="100"
              prop="phone"
          >
            <template slot-scope="{ row }">
              <span v-if="row.gender == 1">
                男
              </span>
              <span v-if="row.gender == 2">
                女
              </span>
            </template>
          </el-table-column>

          <el-table-column
              align="center"
              label="位置"
              min-width="200"
              prop="address"
          ></el-table-column>
          <el-table-column
              align="center"
              fixed="right"
              label="操作"
              prop="icon"
              width="200"
          >
            <template slot-scope="scope">
              <el-button plain type="success" @click="usersumbit(scope.row)"
              >选择
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :current-page="usersearchForm.pageNo"
            :page-size="usersearchForm.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="usr_total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleUserSizeChange"
            @current-change="handleUserCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>


    <el-dialog
        :before-close="handlClose"
        :visible.sync="scanvisible"
        append-to-body
        title="下单人员"
        width="80%"
    >
      <div style="padding-bottom: 40px;">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
                v-model="scansearchForm.name"
                clearable
                placeholder="用户昵称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="80px">
            <el-input
                v-model="scansearchForm.phone"
                clearable
                placeholder="手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getscanGoods()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="scanList" border stripe style="width: 100%;">
          <el-table-column align="center" label="用户头像" min-width="120">
            <template slot-scope="scope"
            ><img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
            />
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="用户昵称"
              min-width="120"
              prop="nickName"
          ></el-table-column>
          <el-table-column
              align="center"
              label="用户手机号"
              min-width="120"
              prop="phone"
          ></el-table-column>
          <el-table-column
              align="center"
              label="性别"
              min-width="100"
              prop="phone"
          >
            <template slot-scope="{ row }">
              <span v-if="row.gender == 1">
                男
              </span>
              <span v-if="row.gender == 2">
                女
              </span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="位置"
              min-width="200"
              prop="address"
          ></el-table-column>

        </el-table>
        <el-pagination
            :current-page="scansearchForm.pageNo"
            :page-size="scansearchForm.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="scan_total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleScanSizeChange"
            @current-change="handleScanCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import VploadImgs from "../inc/VploadImgThree";
import area from "../stash/area.json";

export default {
  name: "ConfigType",
  components: {
    VploadImgs,
  },
  data() {
    return {
      scanvisible: false,
      type: 1,
      id: null,
      userList: [],
      area,
      props: {multiple: true, value: "name", label: "name", children: "area"},
      tableData: [],
      dialogVisible: false,
      filelist: [],
      editForm: {
        prov: [],
        address: "",
        name: "",
        phone: "",
        nickName: null,
        userId: null,
        introduction: null,
      },
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
      },
      usr_total: 0,
      usersearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      scansearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      psarea: [],
      scanList: [],
      scan_total: 0,
      visible: false,
      rules: {
        address: [{required: true, message: "请输入", trigger: "change"}],
        phone: [{required: true, message: "请输入", trigger: "change"}],
        name: [{required: true, message: "请输入", trigger: "change"}],
        prov: [{required: true, message: "请选择", trigger: "change"}],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    xggly(i) {
      this.id = i.id;

      this.selectUser();
      this.type = 2;
    },
    usersumbit(i) {
      console.log(this.type);
      if (this.type == 2) {
        this.$axios
            .post("/admin/store/addStoreUser", {id: this.id, userId: i.userId})
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                },
              });
              this.visible = false;
              this.searchForm.pageNo = 1;
              this.getList();
            });
      }

      if (this.type == 1) {
        this.editForm.userId = i.userId;
        this.editForm.nickName = i.nickName;
        this.visible = false;
      }
    },
    downloadByBlob(row) {
      const that = this
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = row.codeImg
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = 1260
        canvas.height = 900
        const ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, 1260, 900)
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob)
          that.download(url, row.name)
          // 用完释放URL对象
          URL.revokeObjectURL(url)
        })
      }
    },

    download(url, name) {
      const eleLink = document.createElement('a')
      eleLink.download = name
      eleLink.href = url
      eleLink.click()
      eleLink.remove()
    },
    scan(row) {
      if(row){
        this.scansearchForm.id =row.id
      }
      this.scanvisible = true
      this.$axios
          .post("/admin/store/getStoreUserList", this.scansearchForm)
          .then((res) => {
            this.scanList = res.data.records;
            this.scan_total = res.data.total;
          });
    },
    getscanGoods() {
      this.scansearchForm.pageNo = 1;
      this.scan();
    },
    getuser() {
      this.$axios
          .post("/admin/userBase/getUserList", this.usersearchForm)
          .then((res) => {
            this.userList = res.data.records;
            this.usr_total = res.data.total;
          });
    },
    selectUser() {
      this.type = 1;
      this.usersearchForm = {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      };
      this.getuser();
      this.visible = true;
    },
    getStoreGoods() {
      this.usersearchForm.pageNo = 1;
      this.getuser();
    },
    handleScanSizeChange(val) {
      this.scansearchForm.pageSize = val;
      this.scan();
    },
    handleScanCurrentChange(val) {
      this.scansearchForm.pageNo = val;
      this.scan();
    },
    handleUserSizeChange(val) {
      this.usersearchForm.pageSize = val;
      this.getuser();
    },
    handleUserCurrentChange(val) {
      this.usersearchForm.pageNo = val;
      this.getuser();
    },
    getImg(i) {
      this.editForm.cover = i;
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.editForm));
          obj.province = obj.prov[0];
          obj.city = obj.prov[1];
          obj.county = obj.prov[2];
          var ruleForm = {
            address: obj.address,
            city: obj.city,
            county: obj.county,
            cover: obj.cover,
            introduction: obj.introduction,
            name: obj.name,
            phone: obj.phone,
            province: obj.province,
            userId: obj.userId,
          };
          if (obj.id) {
            ruleForm.id = obj.id;
            this.$axios
                .post("/admin/store/updateStore", ruleForm)
                .then((res) => {
                  this.$message({
                    showClose: true,
                    message: "恭喜你，操作成功",
                    type: "success",
                    onClose: () => {
                    },
                  });
                  this.handleClose("editForm");
                  this.searchForm.pageNo = 1;
                  this.getList();
                });
          } else {
            this.$axios.post("admin/store/addStore", ruleForm).then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                },
              });
              this.handleClose("editForm");
              this.searchForm.pageNo = 1;
              this.getList();
            });
          }
        }
      });
    },
    getList() {
      this.$axios
          .post("/admin/store/getStoreList", this.searchForm)
          .then((res) => {
            this.tableData = res.data.records;
            this.total = res.data.total;
          });
    },
    setsu() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.editForm = {
        name: null,
        phone: null,
        type: null,
        prov: [],
        address: null,
        entrepot: [],
      };
      this.fileList = [];
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    handlClose() {
      this.visible = false;
      this.scanvisible = false;
    },

    UpdateButton(row, type) {
      this.$axios
          .post("/admin/store/getStoreInfo", {id: row.id})
          .then((res) => {
            res.data.prov = [res.data.province, res.data.city, res.data.county];
            this.$nextTick(() => {
              this.editForm = {
                introduction: res.data.introduction,
                name: res.data.name,
                phone: res.data.phone,
                prov: res.data.prov,
                address: res.data.address,
                id: res.data.id,
                cover: res.data.cover,
                userId: res.data.userId,
                nickName: res.data.userName,
              };
              this.filelist = [{url: res.data.cover}];
              this.dialogVisible = true;
            });
          });
    },
    delHandle(id) {
      this.$axios
          .post("/admin/store/deleteStore", {
            id: id,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
              },
            });
            this.getList();
          });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.cus_area {
  margin: 10px;
}
</style>
